const CANCEL_SUBSCRIPTION_API = 'https://api.jashsoft.com/pay/subscription/cancel';

class CancelSubscription {
  action(modelInstance) {
    return fetch(CANCEL_SUBSCRIPTION_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerEmail: modelInstance.emailAddress
      })
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Subscription cancellation failed');
      }
      return response.json();
    });
  }
}

export default CancelSubscription;
